<div mat-dialog-content>
    <div class="d-flex flex-column align-items-center">
        <p class="mb-0" style="text-align: left;">{{data.message}}</p>
    </div>
</div>
<div mat-dialog-actions class="mt-2 d-flex justify-content-center">
    <button mat-button class="ml-auto" (click)="actionAndCloseDialog()">
        <span class="font-weight-bold">OK</span>
    </button>
</div>
